var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountMeInBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169,
    height: 58.5,
    viewBox: "0 0 169 58.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7707",
    "data-name": "Group 7707",
    transform: "translate(-0.128 -0.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7698",
    "data-name": "Group 7698",
    transform: "translate(7.439 7.439)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M442.318,375.2H328.17a26.393,26.393,0,0,1-26.27-26.27V346.37a26.393,26.393,0,0,1,26.27-26.27H442.318a26.393,26.393,0,0,1,26.27,26.27v2.557C468.356,363.341,456.732,375.2,442.318,375.2Z",
    transform: "translate(-306.9 -324.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M436.292,351.958H320.981A14.09,14.09,0,0,1,306.8,337.776v-1.395A14.09,14.09,0,0,1,320.981,322.2H436.292a14.09,14.09,0,0,1,14.181,14.181v1.395A14.392,14.392,0,0,1,436.292,351.958Z",
    transform: "translate(-295.408 -317.318)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Send",
    transform: "translate(44.153 40.221)",
    fontSize: 34,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7702",
    "data-name": "Group 7702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7701",
    "data-name": "Group 7701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7699",
    "data-name": "Group 7699",
    transform: "translate(0.128 0.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M439.118,372H324.97a26.393,26.393,0,0,1-26.27-26.27V343.17a26.393,26.393,0,0,1,26.27-26.27H439.118a26.393,26.393,0,0,1,26.27,26.27v2.557A26.243,26.243,0,0,1,439.118,372Z",
    transform: "translate(-298.7 -316.9)",
    fill: "#d13a3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M433.092,348.758H317.781A14.09,14.09,0,0,1,303.6,334.576v-1.395A14.09,14.09,0,0,1,317.781,319h115.31a14.09,14.09,0,0,1,14.181,14.181v1.395A14.09,14.09,0,0,1,433.092,348.758Z",
    transform: "translate(-292.209 -314.118)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7700",
    "data-name": "Group 7700",
    transform: "translate(44.278 3.347)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "COUNT_ME_IN",
    "data-name": "COUNT ME IN",
    transform: "translate(-10.15 29.689)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COUNT ME IN"))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountMeInBtn);
export default __webpack_public_path__ + "static/media/Count-me-in-btn.f8c1501042350f4d52203c6272439300.svg";
export { ForwardRef as ReactComponent };